import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './theme.js'
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"
import "./assets/toast-styles.css"
import { syncStudyPwa } from "./pwa/studyPwa"
import { ehDominioCasamento } from "./components/casamento/rotas"

const toastOptions = {
  position: "top-right",
  timeout: 4000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
  maxToasts: 20,
  newestOnTop: true
}

router.beforeEach((to, from, next) => {
  // No domínio do casamento tudo é casamento. No principal, vale o prefixo.
  // (O `'/casamento' || '/cha-de-panela'` daqui antes só avaliava o primeiro.)
  const ehCasamento = ehDominioCasamento
      || to.path.startsWith('/casamento')
      || to.path.startsWith('/cha-de-panela');

  document.title = ehCasamento ? 'Bruno & Lauana' : 'Lauana Rezende Advocacia';
  next();
});

router.afterEach((to) => {
  syncStudyPwa(to.path);
});

Vue.use(Toast, toastOptions)
Vue.config.productionTip = false

// Reload the page once when a lazy chunk fails to load (stale deploy cache)
router.onError((error) => {
  if (/ChunkLoadError|Loading chunk/.test(error.message)) {
    const reloadKey = 'chunk-reload-' + window.location.pathname;
    if (!sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, '1');
      window.location.reload();
    }
  }
});

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
